var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation30X30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/building/30x30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/building/30x30",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(4, 0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.547,0 C4.72845448,0 0,4.7285176 0,10.5468794 C0,12.5156302 0.545045522,14.4317053 1.58210859,16.0840497 L9.83203059,29.5848757 C9.97277444,29.8133914 10.1837144,29.954075 10.4298697,29.9892313 C10.7637409,30.0419071 11.1330616,29.9013406 11.3263647,29.5673561 L19.5999003,15.943366 C20.5841697,14.3262365 21.094,12.4453763 21.094,10.5468794 C21.094,4.7285176 16.3655455,0 10.547,0 Z M10.547,15.8203191 C7.59395719,15.8203191 5.2735,13.4296931 5.2735,10.5468794 C5.2735,7.64642898 7.64651641,5.27343971 10.547,5.27343971 C13.4474836,5.27343971 15.8205,7.64642898 15.8205,10.5468794 C15.8205,13.412115 13.5352581,15.8203191 10.547,15.8203191 Z",
    id: "Shape",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.547,0 L10.547,5.27343971 C13.4474836,5.27343971 15.8205,7.64642898 15.8205,10.5468794 C15.8205,13.412115 13.5352581,15.8203191 10.547,15.8203191 L10.547,29.9997271 C10.846945,30.0064579 11.1553861,29.8626687 11.3263061,29.5673561 L19.5998417,15.943366 C20.5841697,14.3262365 21.094,12.4453763 21.094,10.5468794 C21.094,4.7285176 16.3655455,0 10.547,0 Z",
    id: "Path",
    fill: "#C60E68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation30X30);
export default __webpack_public_path__ + "static/media/location_30x30.8e9092397be988f9ab391c2c529cf764.svg";
export { ForwardRef as ReactComponent };